import React, { useEffect } from "react";
import { connect } from "react-redux";
import HeaderComponent from "components/card/HeaderComponent";
import ProfileCard from "views/console/team-managements/components/ProfileCard";
import { LucideCake } from "lucide-react";



const BirthdaysTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {

	
return (
	<HeaderComponent
		title="Upcoming Birthdays"
		description="Celebrate your team members' special days"
		bgcolor="bg-purple-50"
		icon={<LucideCake size={20}/>}
		colorTheme="flat-purple"
		shadow="shadow-sm"
		border="border-b"
	>
		<div className= "overflow-y-auto p-1 h-[500px]">
			<ProfileCard
				type="Birthdays"
				name="James Wilson"
				location="Philippines"
				role="HR"
				date="Oct 18, 2025"
			/>
			<ProfileCard
				type="Birthdays"
				name="James Wilson"
				location="Philippines"
				role="HR"
				date="Oct 18, 2025"
			/>
			<ProfileCard
				type="Birthdays"
				name="James Wilson"
				location="Philippines"
				role="HR"
				date="Oct 18, 2025"
			/>
			<ProfileCard
				type="Birthdays"
				name="James Wilson"
				location="Philippines"
				role="HR"
				date="Oct 18, 2025"
			/>
			<ProfileCard
				type="Birthdays"
				name="James Wilson"
				location="Philippines"
				role="HR"
				date="Oct 18, 2025"
			/>
		</div>
		
	</HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
	// recordList: state.trainingClass.trainingClassList?.items,
	// pagination: state.trainingClass.trainingClassList?.pagination,
	// filters: state.trainingClass.trainingClassList?.filters,
	// requesting: state.trainingClass.trainingClassList?.requesting,
	// error: state.trainingClass.trainingClassList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	// doSearch: (filters) => dispatch(getTrainingClassList(filters)),
	// doDelete: (id) => dispatch(doTrainingClassDelete(id)),
	// doRecordReset: () => dispatch(doTrainingClassReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BirthdaysTable);
